/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for ``POST /api/jobs/{job_id}/sequences/{seq_id}/enroll/preview/{preview_id}/commit``.
 *
 * The commit takes no parameters today — the preview session already
 * carries everything needed to enroll — but we keep an explicit (empty)
 * body model so future commit-time options have a stable place to live.
 */
export interface EnrollmentCommitRequest { [key: string]: unknown }
